var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 923.2c-4 0-8-1.6-11.2-4.8-12.8-12-309.6-300.8-309.6-593.6C191.2 148 335.2 4 512 4s320.8 144 320.8 320.8c0 293.6-297.6 581.6-309.6 593.6-3.2 3.2-7.2 4.8-11.2 4.8zM512 36c-159.2 0-288.8 129.6-288.8 288.8 0 248.8 234.4 504 288.8 560 54.4-56 288.8-311.2 288.8-560 0-159.2-129.6-288.8-288.8-288.8z",
    fill: "#0E1856"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 521.6c-108.8 0-196.8-88-196.8-196.8C315.2 216.8 403.2 128 512 128c108.8 0 196.8 88 196.8 196.8 0 108.8-88 196.8-196.8 196.8zM512 144c-100 0-180.8 80.8-180.8 180.8S412 505.6 512 505.6s180.8-80.8 180.8-180.8S612 144 512 144z",
    fill: "#0E1856"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M605.6 332.8c-4.8 0-8-3.2-8-8C597.6 278.4 559.2 240 512 240c-4.8 0-8-3.2-8-8s3.2-8 8-8c56 0 101.6 45.6 101.6 101.6 0 4-4 7.2-8 7.2zM789.6 1020H234.4c-8.8 0-16-7.2-16-16s7.2-16 16-16h556c8.8 0 16 7.2 16 16s-8 16-16.8 16z",
    fill: "#0E1856"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation2);
export default __webpack_public_path__ + "static/media/location2.15ed552ab5998b5961dbeceffd4a2046.svg";
export { ForwardRef as ReactComponent };